{
  "static-content-become-partner": {
    "buttons": {
      "be-partner": "Buďte partnerem"
    },
    "text": {
      "title": "Jste majitelem kosmetického salonu? Přineste ho online ještě dnes!",
      "description": "Nečekejte déle a ještě dnes si naplánujte ukázku, abyste zjistili, jak naše aplikace může změnit správu vašeho salonu. Náš software je uživatelsky přívětivý a přizpůsobitelný jedinečným potřebám vašeho salonu. Je čas posunout váš salon na vyšší úroveň efektivity a spokojenosti zákazníků. Staňte se naším partnerem ještě dnes!"
    }
  }
}
